<template>
    <div v-scroll="onScrollSearch">
        <div>
            <vue-headful :title="$t('title_library')" description="title" />
        </div>
        <v-container fluid fill-height>
            <v-row class="mt-12 mx-12">
                <TopBar />
                <AssignedBook />
                <v-col cols="12">
                    <v-row align="center" justify="center" justify-md="end">
                        <v-col cols="10" md="6" lg="4" xl="3" class="mt-6 mx-6">
                            <v-form v-model="valid" @submit="getBooksByTitle">
                                <v-text-field
                                    data-cy="library-search-textfield"
                                    v-model="search"
                                    :label="$t('store.search')"
                                    :rules="tittleRule"
                                    outlined
                                    rounded
                                    dense
                                >
                                    <template #append>
                                        <v-btn
                                            icon
                                            fab
                                            small
                                            :loading="loading"
                                            @click="getBooksByTitle"
                                        >
                                            <v-icon>fa-search</v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-container v-if="fixedLibrary && fixedLibrarySections.length > 0" v-show="!showSearch">
                <book-carousel-pop-up
                    v-for="(section,id) in fixedLibrarySections"
                    :key="id"
                    :titleCarousel="section.name"
                    :booksList="section.books"

                />
            </v-container>
            <BookSearchContent
                :books="searchBooks.data"
                v-show="showSearch"
                :error-message="searchError"
                :loading="loading"
                :query="search"
                @clean-search="cleanSearch"
            />
            <book-carousel-pop-up
                :titleCarousel="$t('library.title_carousel_4')"
                :booksList="topNewBooksList"
                v-show="!showSearch"
                v-if="!fixedLibrary"
            />
            <book-carousel-pop-up
                :titleCarousel="$t('library.title_carousel_3')"
                :booksList="topRatingBookList"
                v-show="!showSearch"
                v-if="!fixedLibrary"
            />
            <book-carousel-pop-up
                :titleCarousel="$t('library.title_carousel_2')"
                :booksList="topMostRequestedBooksList"
                v-show="!showSearch"
                v-if="!fixedLibrary"
            />
            <book-carousel-pop-up
                :titleCarousel="$t('library.title_carousel_5')"
                :booksList="boughtBookList"
                v-show="!showSearch"
            />
            <book-carousel-pop-up
                :titleCarousel="$t('library.title_carousel_1')"
                :booksList="favoriteBookList"
                v-show="!showSearch"
            />
        </v-container>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import { loadScript } from "vue-plugin-load-script";
import _ from 'lodash';
import AssignedBook from '@/components/home/AssignedBook.vue'
import TopBar from '@/components/home/TopBar.vue'
import BookCarouselPopUpVue from '@/components/library/BookCarouselPopUp.vue'
import BookSearchContent from '@/components/library/BookSearchContent.vue'
import bookService from '../../services/book'

let Airtable = null;

export default {
    data() {
        return {
            favoriteBookListUser: {
                code: 0,
                data: [],
            },
            boughtBookListUser: {
                code: 0,
                data: [],
            },
            topRatingBookListUser: {
                code: 0,
                data: [],
            },
            mostRequestedBooks: {
                code: 0,
                data: [],
            },
            newBooks: {
                code: 0,
                data: [],
            },
            searchBooks: {
                code: 0,
                data: [],
            },
            search: '',
            page: 0,
            sizeForSearch: 30,
            valid: true,
            showSearch: false,
            loading: false,
            searchError: '',
            last: false,
            empty: false,
            payPage: 0,
            paySize: 100,
            fixedLibrary: false,
            fixedLibraryBooks: [],
            fixedLibrarySections: []
        }
    },
    created() {
        this.getFavoriteBooksList()
        this.getBoughtBooksList()
        this.getTopRatingBookList()
        this.getMostRequestedBooksPage()
        this.getNewBooksPage()
    },
    mounted() {
        if (_.endsWith(this.user.school.rbd, "restricted")) {
            this.fixedLibrary = true
            this.loadFixedLibrary(this.user.school.id)
        }
        if (window.ChurnZero) window.ChurnZero.push(['trackEvent', 'library', 'Go to Library']);
    },
    computed: {
        ...mapState({
            user_loaded: (state) => state.userData.user_loaded,
            user_id: (state) => state.userData.user.id,
            user: (state) => state.userData.user
        }),
        favoriteBookList() {
            return this.favoriteBookListUser
        },
        boughtBookList() {
            return this.boughtBookListUser
        },
        topRatingBookList() {
            return this.topRatingBookListUser
        },
        topMostRequestedBooksList() {
            return this.mostRequestedBooks
        },
        topNewBooksList() {
            return this.newBooks
        },
        tittleRule() {
            return [() => !!this.search || this.$t('library.book_tittle_required')]
        },
    },
    components: {
        AssignedBook,
        TopBar,
        'book-carousel-pop-up': BookCarouselPopUpVue,
        BookSearchContent,
    },
    methods: {
        getFavoriteBooksList() {
            bookService
                .getBookListFavoriteByUser(this.user_id)
                .then((response) => {
                    if (response.content.length > 0) {
                        this.favoriteBookListUser = {
                            code: 1,
                            data: response.content,
                        }
                    } else {
                        this.favoriteBookListUser = {
                            code: 2,
                            data: response.content,
                        }
                    }
                })
                .catch((error) => {
                    Sentry.captureException(error)
                    this.favoriteBookListUser = {
                        code: 3,
                        error,
                    }
                })
        },
        getBoughtBooksList() {
            bookService
                .getAllPayBooksByUser(this.user_id, this.payPage, this.paySize)
                .then((response) => {
                    if (response.content && response.content.content.length > 0) {
                        this.boughtBookListUser = {
                            code: 1,
                            data: response.content.content,
                        }
                    } else {
                        this.boughtBookListUser = {
                            code: 2,
                            data: [],
                        }
                    }
                })
                .catch((error) => {
                    Sentry.captureException(error)
                    this.boughtBookListUser = {
                        code: 3,
                        error,
                    }
                })
        },
        getTopRatingBookList() {
            bookService
                .getTopRatingPage(this.user_id)
                .then((response) => {
                    if (response.content && response.content.content.length > 0) {
                        this.topRatingBookListUser = {
                            code: 1,
                            data: response.content.content,
                        }
                    } else {
                        this.topRatingBookListUser = {
                            code: 2,
                            data: [],
                        }
                    }
                })
                .catch((error) => {
                    Sentry.captureException(error)
                    this.topRatingBookListUser = {
                        code: 3,
                        error,
                    }
                })
        },
        getMostRequestedBooksPage() {
            bookService
                .getMostRequestedBooksPage(this.user_id)
                .then((response) => {
                    if (response.content && response.content.content.length > 0) {
                        this.mostRequestedBooks = {
                            code: 1,
                            data: response.content.content,
                        }
                    } else {
                        this.mostRequestedBooks = {
                            code: 2,
                            data: [],
                        }
                    }
                })
                .catch((error) => {
                    Sentry.captureException(error)
                    this.mostRequestedBooks = {
                        code: 3,
                        error,
                    }
                })
        },
        getNewBooksPage() {
            bookService
                .getNewBooksPage(this.user_id)
                .then((response) => {
                    if (response.content && response.content.content.length > 0) {
                        this.newBooks = {
                            code: 1,
                            data: response.content.content,
                        }
                    } else {
                        this.newBooks = {
                            code: 2,
                            data: [],
                        }
                    }
                })
                .catch((error) => {
                    Sentry.captureException(error)
                    this.newBooks = {
                        code: 3,
                        error,
                    }
                })
        },
        async getBooksByTitle($event) {
            if ($event) $event.preventDefault()
            if (this.search) {
                if (this.page === 0) {
                    this.searchBooks = { data: [] }
                }
                this.showSearch = true
                this.loading = true
                this.$ga.event('input', 'searchBook')
                const response = await bookService
                    .getBookListByTittle({ title: this.search, number: this.page, size: this.sizeForSearch })
                    .catch((error) => {
                        Sentry.captureException(error)
                        this.searchError = error.message
                    })
                if (response) {
                    const { content: contentData } = response
                    const { content, last, empty } = contentData
                    this.empty = empty
                    this.last = last
                    if (!empty) {
                        this.$ga.event('books', 'searchBookFound')
                        if (this.fixedLibrary) {
                            const filteredSearchBooks = [...this.searchBooks.data, ...content].filter((book) => {
                                return _.includes(_.map(this.fixedLibraryBooks, 'id'), book.id)
                            })
                            if (filteredSearchBooks.length > 0){
                                this.searchBooks = { data: filteredSearchBooks }
                            } else{
                                this.searchBooks = { data: [] }
                                this.searchError = this.$t('library.not_books_data')
                            }
                        } else {
                            this.searchBooks = { data: [...this.searchBooks.data, ...content] }
                            this.searchError = false
                        }
                    } else {
                        this.$ga.event('books', 'searchNotBookFound')
                        this.searchBooks = { data: [] }
                        this.searchError = this.$t('library.not_books_data')
                    }
                } else {
                    this.$ga.event('books', 'searchNotBookFound')
                    this.searchBooks = { data: [] }
                    this.searchError = this.$t('library.not_books_data')
                }
                this.loading = false
            }
        },
        cleanSearch() {
            this.showSearch = false
        },
        onScrollSearch() {
            if (this.showSearch && !this.last && !this.empty && this.scrollEnds() && this.searchBooks.data.length === this.sizeForSearch) {
                this.page += 1
                this.getBooksByTitle()
            }
        },
        scrollEnds() {
            return window.innerHeight + window.pageYOffset === document.body.offsetHeight
        },
        loadAirtable() {
            loadScript("https://s3.us-east-2.amazonaws.com/beereaders.com/lib/airtable.browser.js")
            .then(() => {
                // Script is loaded, do something
                Airtable = window.require('airtable')
                this.loadFixedLibrary()
            })
            .catch(() => {
                // Failed to fetch script
                console.log('Unable to load Airtable')
            });
        },
        loadFixedLibrary() {
            const vm = this;
            if (Airtable) {
                const base = new Airtable({apiKey: 'keyed4Q3x3VmpjUMK'}).base('app4LuUIH9qFukCVo');
                base('Books').select({
                    // Selecting the first 3 records in Grid view:
                    // maxRecords: 50,
                    view: "Grid view"
                }).eachPage(function page(records, fetchNextPage) {
                    // This function (`page`) will get called for each page of records.
                    records.forEach((record) => {
                        try {                    
                            if (_.includes(record.get('Beereaders ID (from Schools)'), vm.user.school.id.toString())) {
                                vm.fixedLibraryBooks.push({
                                    id: record.get('id'),
                                    title: record.get('title'),
                                    resourceDir: record.get('resourceDir'),
                                    bookAbstract: record.get('bookAbstract'),
                                    fromAge: record.get('fromAge'),
                                    toAge: record.get('toAge')
                                })
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    });

                    // To fetch the next page of records, call `fetchNextPage`.
                    // If there are more records, `page` will get called again.
                    // If there are no more records, `done` will get called.
                    try { 
                        fetchNextPage();
                    } catch(er) { 
                        console.log(er) 
                    }

                }, function done(err) {
                    if (err) console.error(err)
                    _.forEach(_.groupBy(vm.fixedLibraryBooks, 'fromAge'), (group, ageGroup) => {
                        vm.fixedLibrarySections.push(
                            {
                                name: `Edad recomendada ${ageGroup}+`,
                                books: {
                                    code: 1,
                                    data: _.take(group, 10)
                                }
                            }
                        )
                    })
                });
            } else {
                this.loadAirtable()
            }
        }
    },
}
</script>
